import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { FaFilter, FaPlus, FaQuestionCircle, FaTimes, FaTrash } from "react-icons/fa";

const ListViewFilterPanel = ({
  filterPanelOpen,
  externalFilters,
  externalFilterLogic,
  availableFields,
  activeFiltersCount,
  onClose,
  onAddFilter,
  onRemoveFilter,
  onUpdateFilter,
  onUpdateLogic,
  getOperatorsForField,
  isOperatorValueRequired,
  getFieldDataType,
  onApplyFilters,
  onClearFilters,
  showDateHelpModal,
  setShowDateHelpModal
}) => {
  return (
    <div className="filter-sidebar-content" style={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      padding: '20px',
      width: '100%',
      minWidth: '500px',
      overflow: 'hidden'
    }}>
      <div className="filter-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', paddingBottom: '16px', borderBottom: '1px solid #e5e5e5' }}>
        <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#032d60', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <FaFilter />
          Quick Filters
        </h3>
        <button
          className="close-btn"
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '4px',
            color: '#706e6b',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <FaTimes size={18} />
        </button>
      </div>

      <div className="filter-body" style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', paddingRight: '8px', minHeight: 0 }}>
        <div className="mb-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="mb-0">Filter Logic</h6>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={onAddFilter}
            >
              <FaPlus className="me-1" />
              Add Filter
            </Button>
          </div>

          <Form.Select
            value={externalFilterLogic}
            onChange={(e) => onUpdateLogic(e.target.value)}
            className="mb-3"
          >
            <option value="AND">AND (All conditions must be true)</option>
            <option value="OR">OR (Any condition can be true)</option>
          </Form.Select>
        </div>

        {externalFilters.length === 0 ? (
          <div className="text-center text-muted py-4">
            <FaFilter className="mb-2" size={24} />
            <p>No filters configured</p>
            <small>Click "Add Filter" to create filtering rules</small>
          </div>
        ) : (
          <div className="filters-container">
            {externalFilters.map((filter, index) => (
              <div key={filter.id} className="filter-row border rounded p-3 mb-3 bg-light">
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <h6 className="mb-0">Filter {index + 1}</h6>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => onRemoveFilter(filter.id)}
                  >
                    <FaTrash />
                  </Button>
                </div>

                <Row>
                  <Col md={5}>
                    <Form.Group className="mb-2">
                      <Form.Label className="small fw-bold">Field</Form.Label>
                      <Form.Select
                        value={filter.field}
                        onChange={(e) => onUpdateFilter(filter.id, 'field', e.target.value)}
                        size="sm"
                      >
                        <option value="">Select Field</option>
                        {availableFields.map(field => (
                          <option key={field.name} value={field.name}>
                            {field.label}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group className="mb-2">
                      <Form.Label className="small fw-bold">Operator</Form.Label>
                      <Form.Select
                        value={filter.operator}
                        onChange={(e) => onUpdateFilter(filter.id, 'operator', e.target.value)}
                        disabled={!filter.field}
                        size="sm"
                      >
                        <option value="">Select Operator</option>
                        {filter.field && getOperatorsForField(filter.field).map(op => (
                          <option key={op.value} value={op.value}>
                            {op.label}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-2">
                      <Form.Label className="small fw-bold d-flex align-items-center">
                        Value
                        {filter.field && (getFieldDataType(filter.field) === 'date' || getFieldDataType(filter.field) === 'datetime') && isOperatorValueRequired(filter.operator) && (
                          <FaQuestionCircle
                            className="ms-2 text-primary"
                            size={12}
                            style={{ cursor: 'pointer' }}
                            title="Date Filter Help"
                            onClick={() => setShowDateHelpModal(true)}
                          />
                        )}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={filter.value}
                        onChange={(e) => onUpdateFilter(filter.id, 'value', e.target.value)}
                        placeholder={isOperatorValueRequired(filter.operator) ? "Enter value" : "Not required"}
                        disabled={!isOperatorValueRequired(filter.operator)}
                        size="sm"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            ))}
          </div>
        )}

        <div className="filter-actions" style={{
          marginTop: 'auto',
          paddingTop: '16px',
          borderTop: '1px solid #e5e5e5',
          display: 'flex',
          gap: '8px'
        }}>
          <Button
            variant="outline-secondary"
            onClick={onClearFilters}
            style={{ flex: 1 }}
          >
            Clear All
          </Button>
          <Button
            variant="primary"
            onClick={onApplyFilters}
            style={{ flex: 1 }}
          >
            Apply Filters
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ListViewFilterPanel;
